import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.fbq) {
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1428740802233981');
        `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.src = 'https://www.facebook.com/tr?id=1428740802233981&ev=PageView&noscript=1';
        noscript.appendChild(img);
        document.head.appendChild(noscript);
      }
      window.fbq('track', 'PageView');
    }
  }, []);
  return <main className="min-h-screen bg-cream font-sans text-warm-dark selection:bg-terracotta/30 selection:text-navy" data-id="element-256">
      <HeroSection data-id="element-257" />
      <PainSection data-id="element-258" />
      <RevelationSection data-id="element-259" />
      <ValueStack data-id="element-260" />
      <FAQSection data-id="element-261" />
      <GuaranteeSection data-id="element-262" />
      <FinalCTA data-id="element-263" />

      <Footer data-id="element-264" />
    </main>;
}